"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var RecordingAction;
(function (RecordingAction) {
  RecordingAction["Start"] = "Start";
  RecordingAction["Stop"] = "Stop";
  RecordingAction["Pause"] = "Pause";
  RecordingAction["Resume"] = "Resume";
})(RecordingAction || (RecordingAction = {}));
var _default = RecordingAction;
exports.default = _default;
//# sourceMappingURL=enums.js.map
